import React, { createContext, useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_POSITIONS } from '../graphql/queries/positions';
import { usePortfolioContext } from './PortfolioContext';

const PositionContext = createContext();

export const usePositionContext = () => {
  const context = useContext(PositionContext);
  if (!context) {
    throw new Error('usePositionContext must be used within a PositionProvider');
  }
  return context;
};

export const PositionProvider = ({ children }) => {
  const { currentPortfolioId } = usePortfolioContext();
  
  const { loading, error, data, refetch } = useQuery(GET_POSITIONS, {
    variables: { portfolioId: currentPortfolioId },
    skip: !currentPortfolioId,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all'
  });

  // Refetch when portfolio changes
  useEffect(() => {
    if (currentPortfolioId) {
      refetch({ portfolioId: currentPortfolioId });
    }
  }, [currentPortfolioId, refetch]);

  const reloadPositions = () => {
    if (currentPortfolioId) {
      refetch({ portfolioId: currentPortfolioId });
    }
  };

  const positions = data?.positions || [];
  
  const value = {
    positions,
    loading,
    error,
    reloadPositions,
    hasData: !!data
  };

  return (
    <PositionContext.Provider value={value}>
      {children}
    </PositionContext.Provider>
  );
}; 